// @flow
import * as React from 'react';
import styled from 'styled-components';
import * as ss from 'styled-system';
import { isDefined } from 'utils/functional';
import Box from 'components/Box';
import { colors, transition, breakpoints } from '../theme';

export const SmallTile = styled(({ blueBorder, ...props }) => (
  <Box {...props} />
))`
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  word-wrap: break-word;
  ${props => (props.bg ? '' : 'background: white')};
  ${props =>
    isDefined(props.p)
      ? ''
      : `
  padding: 20px;
  @media (min-width: ${breakpoints[1]}) {
    padding: 30px;
  }
  `}
  ${ss.space};
  ${props =>
    props.blueBorder &&
    `
    position: relative;
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 0;
      transform: translateY(5px);
      width: 100%;
      height: 100%;
      background: ${colors.waterBlue};
      transition: all ${transition};
    }
  `}
`;

export const TileHeader = styled(
  ({
    isActive,
    hasError,
    children,
    ...props
  }: {
    isActive?: boolean,
    hasError?: boolean,
    children?: React.Node
  }) => (
    <Box
      position="relative"
      width="100%"
      borderRadius="12px 12px 0 0"
      overflow="hidden"
      {...props}
    >
      <Box py={[16, null, null, 32]} px={[20, null, null, 40]}>
        {children}
      </Box>
    </Box>
  )
)`
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 0;
    transform: translateY(5px);
    width: 100%;
    height: 100%;
    background: ${colors.waterBlue};
    transition: all ${transition};
  }
  ${props =>
    props.hasError &&
    `
    &::before {
      background: ${colors.scarlet};
    }
  `}
  ${props =>
    props.isActive &&
    `
    color: white;
    &::before {
      transform: translateY(100%);
    }
  `}
`;

export const TileBody = (props?: Object) => (
  <Box p={[20, null, null, 40]} borderRadius="0 0 12px 12px" {...props} />
);

const Tile = styled(
  ({ children, blueBorder, ...props }: { children: React.Node }) => (
    <Box
      borderRadius="12px"
      boxShadow="0 2px 4px rgba(0, 0, 0, 0.1)"
      bg="white"
      {...props}
    >
      {children}
    </Box>
  )
)`
  ${props =>
    props.blueBorder &&
    `
    position: relative;
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 0;
      transform: translateY(5px);
      width: 100%;
      height: 100%;
      background: ${colors.waterBlue};
      transition: all ${transition};
    }
  `}
`;

export default Tile;
